import PropTypes from 'prop-types';
import { Component } from 'react';
import { URANUS_LAYER } from 'HubStyleTokens/sizes';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { LORAX, OZ } from 'HubStyleTokens/colors';
import UILink from 'UIComponents/link/UILink';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import RequestStatus from '../../constants/edit/RequestStatus';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSaveStatus = styled.span.withConfig({
  displayName: "SaveStatus__StyledSaveStatus",
  componentId: "sc-1mpfa01-0"
})(["font-size:12px;"]);
class SaveStatus extends Component {
  getSaveInfoTooltip() {
    const {
      onVersionHistoryClick
    } = this.props;
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "knowledgeContentUI.edit.saveStatus.saveInfoTooltip_jsx",
      elements: {
        Link: linkProps => /*#__PURE__*/_jsx(UILink, {
          onClick: onVersionHistoryClick,
          children: linkProps.children
        })
      }
    });
  }
  getLastSavedString() {
    const {
      article
    } = this.props;
    const {
      authorName_temp: authorName,
      values: {
        hs_updated_at
      }
    } = article;
    const updatedAt = I18n.moment(Math.min(hs_updated_at || 0, new Date().valueOf())).format('llll');
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.edit.saveStatus.updated",
      options: {
        authorName,
        updatedAt
      }
    });
  }
  renderFailedStatus() {
    return /*#__PURE__*/_jsxs("span", {
      "data-test-id": "article-save-status-failed",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        className: "m-right-1",
        color: LORAX,
        name: "remove",
        size: "small"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.edit.saveStatus.error"
      })]
    });
  }
  renderPendingStatus() {
    return /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      "data-test-id": "article-save-status-pending",
      children: [/*#__PURE__*/_jsx(UILoadingSpinner, {
        className: "m-right-1",
        size: "extra-small",
        use: "success"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.edit.saveStatus.saving"
      })]
    });
  }
  renderSucceededStatus() {
    return /*#__PURE__*/_jsx(UITooltip, {
      placement: "bottom",
      title: this.getLastSavedString()
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      ,
      zIndex: parseInt(URANUS_LAYER, 10),
      children: /*#__PURE__*/_jsxs("span", {
        "data-test-id": "article-save-status-succeeded",
        children: [/*#__PURE__*/_jsx(UIIcon, {
          className: "m-right-1",
          color: OZ,
          name: "success",
          size: "small"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.edit.saveStatus.saved"
        })]
      })
    });
  }
  renderNoUnsavedChangesStatus() {
    return /*#__PURE__*/_jsx(UITooltip, {
      placement: "bottom",
      title: this.getLastSavedString()
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      ,
      zIndex: parseInt(URANUS_LAYER, 10),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.edit.saveStatus.noUnsavedChanges"
      })
    });
  }
  renderStatus(status) {
    switch (status) {
      case RequestStatus.PENDING:
        return this.renderPendingStatus();
      case RequestStatus.SUCCEEDED:
        return this.renderSucceededStatus();
      case RequestStatus.FAILED:
        return this.renderFailedStatus();
      case RequestStatus.UNINITIALIZED:
        return this.renderNoUnsavedChangesStatus();
      default:
        return null;
    }
  }
  render() {
    const {
      status
    } = this.props;
    return /*#__PURE__*/_jsx(StyledSaveStatus, {
      children: this.renderStatus(status)
    });
  }
}
SaveStatus.propTypes = {
  onVersionHistoryClick: PropTypes.func.isRequired,
  status: PropTypes.oneOf([RequestStatus.UNINITIALIZED, RequestStatus.PENDING, RequestStatus.SUCCEEDED, RequestStatus.FAILED])
};
export default SaveStatus;